import { render, staticRenderFns } from "./CategoryDetailsPage.vue?vue&type=template&id=6edd4777&"
import script from "./CategoryDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CategoryDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDetailsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports